module.exports = __webpack_public_path__ + "img/hover-cods.a3ecd563.png";